import dayjs from 'dayjs';

// SQL datetime2 records local database clock time; mssql serializes those components with Z.
// Use only for timestamps generated by SYSDATETIME/GETDATE, not actual UTC instants.
export const formatSqlLocalTimestamp = (value, pattern = 'DD/MM/YYYY HH:mm') => {
  if (!value || typeof value !== 'string') return '-';
  const date = dayjs(value.replace(/Z$/i, ''));
  return date.isValid() ? date.format(pattern) : '-';
};
